import type { SnackbarTypes } from './Snackbar.types';

export const SNACKBAR_SUCCESS_DURATION_TIME = 3000;
export const SNACKBAR_ERROR_DURATION_TIME = 10000;

export const DEFAULT_ERROR_MESSAGE = 'An unexpected error occurred.';

export const SNACKBAR_TYPE = {
  ERROR: 'error',
  INFO: 'info',
  NOTIFICATION: 'notification',
  SCHEDULE: 'schedule',
  SUCCESS: 'success',
  WARNING: 'warning',
} as const;

export const SNACKBAR_DURATION_MAPPER: Record<SnackbarTypes, number> = {
  [SNACKBAR_TYPE.ERROR]: SNACKBAR_ERROR_DURATION_TIME,
  [SNACKBAR_TYPE.INFO]: SNACKBAR_SUCCESS_DURATION_TIME,
  [SNACKBAR_TYPE.NOTIFICATION]: SNACKBAR_SUCCESS_DURATION_TIME,
  [SNACKBAR_TYPE.SCHEDULE]: SNACKBAR_SUCCESS_DURATION_TIME,
  [SNACKBAR_TYPE.SUCCESS]: SNACKBAR_SUCCESS_DURATION_TIME,
  [SNACKBAR_TYPE.WARNING]: SNACKBAR_SUCCESS_DURATION_TIME,
};
